import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { VideoSDKMeeting } from "@videosdk.live/rtc-js-prebuilt";

const JoinAsAttendee = () => {
  const obj = JSON.parse(localStorage.getItem("authEventKagoUser"));
  const userFullName = obj?.data?.data?.firstName ? `${obj?.data?.data?.firstName} ${obj?.data?.data?.lastName}` : "Guest User";
  const userId = obj?.data?.data?.id;
  const params = useParams();
  const eventID = params.eventID;
  const eventName = params.eventName;
  const myEventName = eventName.replace(/-/g, " ");
  document.title = `${myEventName} | Webinar`;
  useEffect(() => {
    const apiKey = process.env.REACT_APP_VIDEOSDK_API;
    const meetingId = `${eventID}`;
    const name = `${userFullName}`;

    const config = {
      name: name,
      meetingId: meetingId,
      apiKey: apiKey,
      participantId: userId,
      region: "sg001", // region for new meeting

      containerId: null,
      redirectOnLeave: `https://kago.digital/`,
      theme: "LIGHT",
      micEnabled: true,
      webcamEnabled: true,
      participantCanToggleSelfWebcam: false,
      participantCanToggleSelfMic: false,
      participantCanLeave: true, // if false, leave button won't be visible

      chatEnabled: true,
      screenShareEnabled: false,
      pollEnabled: false,
      whiteboardEnabled: false,
      raiseHandEnabled: true,

      recording: {
        autoStart: false, // auto start recording on participant joined
        enabled: false,
        webhookUrl: "https://www.videosdk.live/callback",
        awsDirPath: `/kago/webinar/${meetingId}/`, // automatically save recording in this s3 path
      },

      livestream: {
        autoStart: false,
        enabled: false,
      },

      layout: {
        type: "SPOTLIGHT", // "SPOTLIGHT" | "SIDEBAR" | "GRID"
        priority: "SPEAKER", // "SPEAKER" | "PIN",
        // gridSize: 3,
      },

      branding: {
        enabled: false,
        logoURL: null,
        name: myEventName,
        poweredBy: false,
      },

      permissions: {
        pin: true,
        askToJoin: true, // Ask joined participants for entry in meeting
        canCreatePoll: false,
        toggleParticipantMic: false, // Can toggle other participant's mic
        toggleParticipantWebcam: false, // Can toggle other participant's webcam
        drawOnWhiteboard: false, // Can draw on whiteboard
        toggleWhiteboard: false, // Can toggle whiteboard
        toggleRecording: false, // Can toggle meeting recording
        toggleLivestream: false, //can toggle live stream
        removeParticipant: false, // Can remove participant
        endMeeting: false, // Can end meeting
        changeLayout: false, //can change layout
      },

      joinScreen: {
        visible: true, // Show the join screen ?
        title: myEventName, // Meeting title
        // meetingUrl: window.location.href, // Meeting joining url
      },

      leftScreen: {
        // visible when redirect on leave not provieded
        actionButton: {
          // optional action button
          label: "Kago Events", // action button label
          href: `https://events.kago.digital/${eventName}/webinar/${eventID}`, // action button href
        },
      },

      notificationSoundEnabled: true,

      debug: false, // pop up error during invalid config or netwrok error

      maxResolution: "hd", // "hd" or "sd"
      // you can change made to conference or viewer
      mode: "CONFERENCE",
      // For more features check: /prebuilt/guide/prebuilt-video-and-audio-calling/getting-started

      //Set Session Close And Time
      autoCloseConfig: {
        type: "session-end-and-deactivate",
        duration: 2,
      },
    };

    const meeting = new VideoSDKMeeting();
    meeting.init(config);
  }, []);

  return <div></div>;
};

export default JoinAsAttendee;
